import React from "react";
import { Calendar } from "lucide-react";

const columns = [
  {
    title: "Product",
    links: ["Features", "Pricing", "Booking page", "Integrations", "Mobile"],
  },
  {
    title: "Industries",
    links: [
      "Hair salons",
      "Barbers",
      "Beauty & nails",
      "Makeup artists",
      "Wellness",
    ],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Blog", "Contact", "Partners"],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card/40 px-4 pb-8 pt-12 sm:pt-16">
      <div className="mx-auto max-w-6xl">
        {/* Brand block + columns */}
        <div className="grid gap-8 sm:gap-10 lg:grid-cols-[1.5fr_repeat(3,1fr)] lg:gap-12">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <div className="flex size-9 items-center justify-center rounded-xl bg-gradient-to-br from-violet-400 to-fuchsia-400 shadow-lg shadow-violet-500/30">
                <Calendar className="size-5 text-white" />
              </div>
              <span className="font-heading text-xl font-bold iridescent-text sm:text-2xl">
                SlotBook
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              The premium booking and management platform for modern salons,
              barbers and beauty professionals. Proudly built in Australia.
            </p>
          </div>

          {/* On mobile: 3 columns side by side (compact). sm+: equally spaced */}
          <div className="grid grid-cols-3 gap-6 sm:gap-8 lg:col-span-3 lg:contents">
            {columns.map((col) => (
              <div key={col.title}>
                <h3 className="text-xs font-bold uppercase tracking-wider text-foreground sm:text-sm">
                  {col.title}
                </h3>
                <ul className="mt-3 flex flex-col gap-2 sm:gap-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#"
                        className="text-xs text-muted-foreground transition-colors hover:text-foreground sm:text-sm"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-border pt-5 text-xs text-muted-foreground sm:flex-row sm:text-sm">
          <p>
            © {new Date().getFullYear()} SlotBook. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="transition-colors hover:text-foreground">
              Privacy
            </a>
            <a href="#" className="transition-colors hover:text-foreground">
              Terms
            </a>
            <a href="#" className="transition-colors hover:text-foreground">
              Security
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
